module.exports = __webpack_public_path__ + "static/media/Test48.32eed48e.bmp";